import React from 'react';
import React3 from 'react-three-renderer';
import * as THREE from 'three';
import Bikes from './Bikes';
import Rack from './Rack';
import { importObj } from './util/import';
import { OrbitControls } from './util/controls';
import { Animate } from 'react-move';
import Room from './Room';
import * as Actions from '../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { viewSet } from './sceneUtils';
import { easeExpInOut } from 'd3-ease';
import orbitIcon from './assets/img/orbit.png';

class ResultsScene extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      clicked: false,
      cubeRotation: new THREE.Euler(),
      geometry: {
        bike: new THREE.Geometry(),
        bikeVertical: new THREE.Geometry(),
        bikeDouble: new THREE.Geometry(),
        bikeVarsity: new THREE.Geometry(),
        rackDouble: new THREE.Geometry(),
        rackVertical: new THREE.Geometry(),
        rackHalfVertical: new THREE.Geometry(),
        rackVarsity: new THREE.Geometry(),
        rackVerticalSupport: new THREE.Geometry(),
        rackVerticalBeams: new THREE.Geometry()
      },
      cameraProps: {
        position: new THREE.Vector3(
          -183.4843428106924,
          65.099700784595704,
          -13.594309327572573
        ),
        // position: new THREE.Vector3(0, 701.1363529164521, 15.691279059880623),
        quaternion: new THREE.Quaternion()
      }
    };

    this._onAnimate = () => {
      if (!this.init && this.react3) {
        this.init = true;
        const renderer = this.react3._canvas.userData.markup.childrenMarkup[0]
          .threeObject._renderer;

        // this.cubeMap = hdrCubeMap(renderer);
      }
      // this.scene.background = this.cubeMap;
      // console.log(this.cubeMap);
      // console.log('rendering');
      // console.log(this.camera.position);
    };
  }

  configToRack = (key, verticalSupport = false, verticalBeam = false) => {
    const {
      rackDouble,
      rackVarsity,
      rackHalfVertical,
      rackVertical,
      rackVerticalSupport,
      rackVerticalBeams
    } = this.state.geometry;

    switch (this.props.configuration.types[key].productType) {
      case 'VARSITY':
        return rackVarsity;
      case 'VERTICAL':
        return verticalSupport
          ? rackVerticalSupport
          : verticalBeam
          ? rackVerticalBeams
          : rackHalfVertical;

      case 'DOUBLE':
        return rackDouble;
      default:
        return rackDouble;
    }
  };
  configToBike = (key) => {
    const { bikeVertical, bikeDouble, bikeVarsity } = this.state.geometry;

    switch (this.props.configuration.types[key].productType) {
      case 'VARSITY':
        return bikeVarsity;
      case 'VERTICAL':
        return bikeVertical;
      case 'DOUBLE':
        return bikeDouble;
      default:
        return bikeVertical;
    }
  };

  componentDidMount() {
    const controls = new OrbitControls(this.camera, this.sceneContainer);
    controls.target = new THREE.Vector3(0, 65, 0);
    controls.maxPolarAngle = Math.PI / 2;
    controls.minPolarAngle = -Math.PI / 2;
    controls.update();
    this.controls = controls;
    this.controlsEnable(false);

    importObj('./assets/3D/bike_vertical_sm.obj', this.loadGeometry, 'bike');
    importObj(
      './assets/3D/rack_vertical_xsm.obj',
      this.loadGeometry,
      'rackVertical'
    );
    importObj(
      './assets/3D/sidestage_sm.obj',
      this.loadGeometry,
      'rackHalfVertical'
    );
    importObj('./assets/3D/varsity_bike.obj', this.loadGeometry, 'bikeVarsity');
    importObj(
      './assets/3D/sidestage_bike.obj',
      this.loadGeometry,
      'bikeVertical'
    );
    importObj('./assets/3D/double_bike.obj', this.loadGeometry, 'bikeDouble');

    importObj(
      './assets/3D/vertical_support.obj',
      this.loadGeometry,
      'rackVerticalSupport'
    );
    importObj(
      './assets/3D/vertical_beams.obj',
      this.loadGeometry,
      'rackVerticalBeams'
    );
    importObj(
      './assets/3D/varsity_scaled_welded.obj',
      this.loadGeometry,
      'rackVarsity'
    );
    importObj(
      './assets/3D/double_half_scaled.obj',
      this.loadGeometry,
      'rackDouble'
    );
    // viewSet(this, this.width, this.height, this.props.configuration.dim);
  }

  componentDidUpdate(prevProps) {
    if (this.props.ui.mouseOverDashboard !== prevProps.ui.mouseOverDashboard) {
      this.controlsEnable(this.props.ui.mouseOverDashboard);
    }
    if (prevProps.parameters.positions !== this.props.parameters.positions) {
      // viewSet(this, this.width, this.height);
    }
    if (prevProps.configuration !== this.props.configuration) {
      if (
        prevProps.configuration.dim.width !==
          this.props.configuration.dim.width ||
        prevProps.configuration.dim.length !==
          this.props.configuration.dim.length
      ) {
        viewSet(this, this.width, this.height, this.props.configuration.dim);
      } else {
        this._renderTrigger();
        this.forceUpdate();
      }
    }
  }

  controlsEnable = (enabled) => {
    this.controls.enablePan = enabled;
    this.controls.enableZoom = enabled;
    this.controls.enableRotate = enabled;
    // this.controls.target = new THREE.Vector3(0, 65, 0);
    this.controls.update();
  };

  loadGeometry = (geometry, key) => {
    this.setState(
      { geometry: { ...this.state.geometry, [key]: geometry } },
      this._renderTrigger
    );
  };

  get container() {
    return document.getElementById('scene-container');
  }

  get width() {
    return this.container ? this.container.clientWidth : 0;
  }
  get height() {
    return this.container ? this.container.clientHeight : 0;
  }

  fog = () => new THREE.Fog(0xf0f0f0, this.size, this.size * 2);
  ambientColor = 0x000000;
  get size() {
    const {
      configuration: {
        dim: { length, width }
      }
    } = this.props;
    const size = Math.max(length, width);
    return size;
  }
  shadowSize = () => {
    return 2 * this.size;
  };
  lightPositions = [
    new THREE.Vector3(
      -this.shadowSize(),
      this.shadowSize() * 2,
      -this.shadowSize()
    ),
    new THREE.Vector3(
      -this.shadowSize(),
      -this.shadowSize(),
      this.shadowSize()
    ),
    new THREE.Vector3(this.shadowSize(), -this.shadowSize(), this.shadowSize()),
    new THREE.Vector3(-this.shadowSize(), this.shadowSize(), this.shadowSize())
  ];
  lightTarget = new THREE.Vector3(0, 0, 0);
  groundQuaternion = new THREE.Quaternion().setFromAxisAngle(
    new THREE.Vector3(1, 0, 0),
    -Math.PI / 2
  );

  _onManualRenderTriggerCreated = (renderTrigger) => {
    // assign to variable to be able to reuse the trigger
    this._renderTrigger = renderTrigger;
  };

  render() {
    const { width, height, ambientColor, fog } = this;

    const shadowSize = this.shadowSize();
    const {
      geometry: {
        bike,
        rackDouble,
        rackVertical,
        rackVarsity,
        rackHalfVertical,
        bikeVertical
      }
    } = this.state;
    const {
      parameters: { renderBikes, rows, columns },
      actions,
      configuration,
      configuration: {
        types,
        dim,
        dim: { walkway },
        types: { top, bottom, fields }
      }
    } = this.props;
    const thickness = 0.5;
    const floorPosition = new THREE.Vector3(0, thickness, 0);
    const topCount = top.productType === 'DOUBLE' ? top.count / 2 : top.count;
    const bottomCount =
      bottom.productType === 'DOUBLE'
        ? Math.floor(bottom.count / 2)
        : bottom.count;
    const fieldsCount = fields
      ? fields.productType === 'DOUBLE'
        ? fields.count / 2
        : fields.count
      : 0;

    const isFields = fields && fields.fields * fields.count > bottom.count;
    const topPositions = new Array(topCount).fill(1).map((t, i) => {
      const spacing =
        top.productType === 'DOUBLE' ? top.dim.width * 2 : top.dim.width;

      const xAdj = false
        ? 0
        : (dim.width - (topCount + 1) * spacing) / 2 - dim.width / 2;
      const x = xAdj + spacing + spacing * i;
      return new THREE.Vector3(x, 0, 0);
    });
    const bottomPositions = bottomCount
      ? new Array(bottomCount).fill(1).map((t, i) => {
          const spacing =
            bottom.productType === 'DOUBLE'
              ? bottom.dim.width * 2
              : bottom.dim.width;

          const xAdj = false
            ? 0
            : (dim.width - (bottomCount + 1) * spacing) / 2 - dim.width / 2;
          const x = xAdj + spacing + spacing * i;
          return new THREE.Vector3(x, 0, 0);
        })
      : [];
    return (
      <div
        id='scene-container'
        onClick={() => {
          !this.state.clicked &&
            this.setState({ clicked: true }, () => {
              this.props.actions.mouseOverDashboard(true);
            });
        }}
        onMouseLeave={() => {
          this.state.clicked &&
            this.setState({ clicked: false }, () => {
              this.props.actions.mouseOverDashboard(false);
            });
        }}
        ref={(node) => {
          this.sceneContainer = node;
        }}
      >
        <Animate
          show={!this.props.ui.mouseOverDashboard}
          start={{
            opacity: 0
          }}
          enter={{
            opacity: [1],
            timing: { duration: 1000, ease: easeExpInOut }
          }}
          leave={{
            opacity: [0],
            timing: { duration: 1000, ease: easeExpInOut }
          }}
        >
          {(style) => {
            return (
              <div style={{ ...style }} id='scene-overlay'>
                <img src={orbitIcon} />
                <div className='scene-prompt'>click to activate scene</div>
              </div>
            );
          }}
        </Animate>
        <Animate
          key='corner'
          show={this.props.ui.mouseOverDashboard}
          start={{
            opacity: 0
          }}
          enter={{
            opacity: [1],
            timing: { duration: 1000, ease: easeExpInOut }
          }}
          leave={{
            opacity: [0],
            timing: { duration: 1000, ease: easeExpInOut }
          }}
        >
          {(style) => {
            return (
              <div style={{ ...style }} id='scene-overlay-corner'>
                <img src={orbitIcon} />
                <div className='scene-prompt'>
                  click and drag to orbit | scroll or pinch to zoom
                </div>
              </div>
            );
          }}
        </Animate>
        <React3
          ref={(node) => {
            this.react3 = node;
          }}
          mainCamera='camera'
          width={width}
          height={height}
          onAnimate={this._onAnimate}
          forceManualRender={!this.props.ui.mouseOverDashboard}
          clearColor={fog().color}
          gammaInput
          gammaOutput
          shadowMapEnabled
          antialias
          onManualRenderTriggerCreated={this._onManualRenderTriggerCreated}
        >
          <scene
            ref={(node) => {
              this.scene = node;
            }}
            fog={fog()}
          >
            <perspectiveCamera
              ref={(node) => {
                this.camera = node;
              }}
              name='camera'
              fov={45}
              aspect={width / height}
              near={0.1}
              far={10000}
              {...this.state.cameraProps}
            />
            <ambientLight color={ambientColor} />
            {this.lightPositions.map((lightPosition, li) => {
              return li === 0 ? (
                <object3D key={li}>
                  <directionalLight
                    color={0xffffff}
                    intensity={0.3}
                    castShadow={true}
                    shadowMapWidth={2048}
                    shadowMapHeight={2048}
                    shadowCameraLeft={-shadowSize}
                    shadowCameraRight={shadowSize}
                    shadowCameraTop={shadowSize}
                    shadowCameraBottom={-shadowSize}
                    shadowCameraFar={3 * shadowSize}
                    shadowCameraNear={shadowSize}
                    position={lightPosition}
                    lookAt={this.lightTarget}
                  />
                  <directionalLight
                    color={0xffffff}
                    intensity={0.5}
                    key={li}
                    position={lightPosition}
                    lookAt={this.lightTarget}
                  />
                </object3D>
              ) : (
                <directionalLight
                  color={0xffffff}
                  intensity={0.2}
                  key={li}
                  position={lightPosition}
                  lookAt={this.lightTarget}
                />
              );
            })}
            {/* <directionalLight
              color={0xffffff}
              intensity={0.4}
              position={this.lightPosition}
              lookAt={this.lightTarget}
            /> */}
            <hemisphereLight
              skyColor={0xffffff}
              groundColor={0xffffff}
              intensity={0.2}
            />
            <Room configuration={configuration} />
            {/* <mesh quaternion={this.groundQuaternion}>
              <planeBufferGeometry
                width={10000}
                height={10000}
                widthSegments={1}
                heightSegments={1}
              />
              <meshLambertMaterial color={0x999999} />
            </mesh> */}
            <object3D frustumCulled position={floorPosition}>
              {true && (
                <object3D
                  frustumCulled
                  position={new THREE.Vector3(0, thickness, -dim.length / 2)}
                >
                  <Rack
                    key={'rack' + (topPositions || []).length}
                    isRack={true}
                    geometry={this.configToRack('top')}
                    {...this.props.parameters}
                    positions={topPositions}
                    actions={actions}
                    render={this._renderTrigger}
                  />
                  <Rack
                    isRack={false}
                    key={(topPositions || []).length}
                    geometry={this.configToBike('top')}
                    {...this.props.parameters}
                    positions={topPositions}
                    actions={actions}
                    render={this._renderTrigger}
                  />
                </object3D>
              )}
              {isFields && (
                <object3D
                  frustumCulled
                  position={new THREE.Vector3(0, thickness, dim.length / 2)}
                >
                  {new Array(fields.fields).fill(1).map((d, i) => {
                    let x =
                      // -fields.dim.depth +
                      -dim.width / 2 +
                      fields.dim.depth * i +
                      (i % 2 === 1 ? fields.dim.depth : 0) +
                      walkway * Math.ceil(i / 2);
                    if (i === fields.fields - 1 && fields.fields % 2 === 0) {
                      x = dim.width / 2;
                    }
                    let y = Math.floor(-fields.dim.margin);
                    const spacing =
                      fields.productType === 'DOUBLE'
                        ? fields.dim.width * 2
                        : fields.dim.width;

                    const positions = new Array(fieldsCount)
                      .fill(1)
                      .map((t, j) => {
                        y -= j > 0 ? spacing : 0;
                        return { x, y };
                      });

                    const positions1 = [
                      new THREE.Vector3(
                        x,
                        0,
                        Math.floor(-fields.dim.margin) -
                          ((fieldsCount - 1) * spacing) / 2
                      )
                    ];
                    const positions2 = positions
                      .filter(
                        (el, j) =>
                          j % 3 === 1 ||
                          (j === positions.length - 1 &&
                            positions.length % 3 === 1)
                      )
                      .map(
                        ({ x, y }) =>
                          new THREE.Vector3(x, 0, y + fields.dim.width / 2)
                      );
                    const positions3 = positions.map(
                      ({ x, y }) => new THREE.Vector3(x, 0, y)
                    );

                    return (
                      <object3D frustumCulled key={i}>
                        <Rack
                          isRack={true}
                          key={'rack' + (bottomPositions || []).length}
                          geometry={this.configToRack('fields')}
                          {...this.props.parameters}
                          positions={positions3}
                          actions={actions}
                          flip={i % 2 === 1}
                          rotate
                          render={this._renderTrigger}
                        />
                        <Rack
                          isRack={false}
                          key={(positions3 || []).length}
                          geometry={this.configToBike('fields')}
                          {...this.props.parameters}
                          positions={positions3}
                          actions={actions}
                          flip={i % 2 === 1}
                          rotate
                          render={this._renderTrigger}
                        />
                        {fields.productType === 'VERTICAL' &&
                          i !== 0 &&
                          (fields.fields % 2 === 1 ||
                            i !== fields.fields - 1) &&
                          i % 2 === 0 && (
                            <object3D frustumCulled>
                              <Rack
                                isRack={true}
                                key={'rack' + (positions1 || []).length}
                                geometry={this.configToRack(
                                  'fields',
                                  false,
                                  true
                                )}
                                {...this.props.parameters}
                                positions={positions1}
                                scaleLength={(fieldsCount * spacing) / 171.22}
                                actions={actions}
                                flip={i % 2 === 1}
                                rotate
                                render={this._renderTrigger}
                              />
                              <Rack
                                isRack={true}
                                key={(positions2 || []).length}
                                geometry={this.configToRack('fields', true)}
                                {...this.props.parameters}
                                positions={positions2}
                                actions={actions}
                                flip={i % 2 === 1}
                                rotate
                                render={this._renderTrigger}
                              />
                            </object3D>
                          )}
                      </object3D>
                    );
                  })}
                </object3D>
              )}
              {!isFields && (
                <object3D
                  frustumCulled
                  position={new THREE.Vector3(0, thickness, dim.length / 2)}
                >
                  <Rack
                    isRack={true}
                    key={'rack' + (bottomPositions || []).length}
                    geometry={this.configToRack('bottom')}
                    {...this.props.parameters}
                    positions={bottomPositions}
                    actions={actions}
                    flip
                    render={this._renderTrigger}
                  />
                  <Rack
                    isRack={false}
                    key={(bottomPositions || []).length}
                    geometry={this.configToBike('bottom')}
                    {...this.props.parameters}
                    positions={bottomPositions}
                    actions={actions}
                    flip
                    render={this._renderTrigger}
                  />
                </object3D>
              )}
            </object3D>
          </scene>
        </React3>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    parameters: state.parameters,
    ui: state.ui
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultsScene);



// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/index.js